/**
 * @overview 考核规则详情
 * @author 3173
 * @date 2020-10
 */
import React from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool, utils_tool} from '@/tool'
import 'antd/dist/antd.css';
import positionRuleColumns from "./positionRuleColumns";
import PositionRuleImport from "./positionRuleImport";
import scaleRuleColumns from "./scaleRuleColumns";
import dealerRuleColumns from "./dealerRuleColumns";
import DealerRuleImport from "./dealerRuleImport";
import '@/styles/containers/report/index.less'

let {WizContainer, WizReduxTemplatem, modelUtils} = framework_tool;
let {WizCard, WizIcon, WizTable, WizButton, WizPopconfirm, WizModal, WizRow, WizCol, WizTabs, WizSearchBar, WizDataTable, WizText, WizAlert, WizBrowserExport, WizSpin, WizInputNumber, WizForm} = component_tool;
let {checkStrLength, getPageData, Session} = utils_tool;

class AssessmentRulesList extends WizContainer {

  componentName = 'assessmentRulesList';

  constructor(props) {
    super(props);
    const {history} = props
    let initialValue = {}
    if (history.location && history.location.pathname === '/live/liveList/liveStatisticsList/assessmentRulesList') { 
      if (history.location && history.location.record) {
        initialValue = history.location.record
        Session.set('liveStatistics', initialValue)
      } else {
        initialValue = Session.get('liveStatistics') || {}
      }
    } else if (history.location && history.location.pathname === '/trainingStatistics/trainingStatisticsList/assessmentRulesList') { 
      if (history.location && history.location.record) {
        initialValue = history.location.record
        Session.set('trainingStatisticsAssessmentRulesList', initialValue)
      } else {
        initialValue = Session.get('trainingStatisticsAssessmentRulesList') || {}
      }
    } 

    //initialValue.id = 1 //测试用
    this.state = {
      apiParams: {},
      positionVisible: false,
      dealerVisible: false,
      scaleVisible: false,
      scaleRecord: undefined, //规模数据
      importModalKey: new Date().getTime(),
    }
    this.initialValue = initialValue
  }

  _componentWillMount() {
    const {history} = this.props;

  }

  _componentDidMount() {
    const {history} = this.props;
    this.getPositionRuleList();

  }

  /** 获取岗位组考核规则 */
  getPositionRuleList(other = {}) {
    if (this.initialValue.id) {
      this.doAction({
        path: 'positionRule/list',
        payload: {
          key: 'positionRules',
          apiParams: {...other, statisticsRuleId: this.initialValue.id}
        },
        autoInit: true,
      })
    }
  }

  /** 获取考核经销商 */
  getDealerRuleList(other = {}) {
    if (this.initialValue.id) {
      this.doAction({
        path: 'dealerRule/listByPage',
        payload: {
          key: 'dealerRules',
          apiParams: {
            ...this.state.apiParams,
            ...other,
            statisticsRuleId: this.initialValue.id}
        },
        autoInit: true,
      })
    }
  }

  /** 获取经销商规模列表 */
  getScaleRuleList(other = {}) {
    if (this.initialValue.id) {
      this.doAction({
        path: 'scaleRule/list',
        payload: {
          key: 'scaleRules',
          apiParams: {...other, delFlag: 0, statisticsRuleId: this.initialValue.id}
        },
        autoInit: true,
      })
    }
  }

  /**保存规模规则 */
  saveScale(values) {
    let {scaleRecord} = this.state;
    this.setState({scaleVisible:false})
    let path = 'scaleRule/add'
    if (scaleRecord && scaleRecord.id) {
      path = 'scaleRule/update'
    }
    this.doAction({
      path: path,
      payload: {
        key: 'saveScale',
        apiParams: {
          ...values,
          id: scaleRecord && scaleRecord.id ? scaleRecord.id : null,
          statisticsRuleId: this.initialValue.id
        }
      },
      autoInit: true,
    })
  }

  /** 导入岗位组规则 */
  importPositionRule(other = {}) {
    this.doAction({
      path: 'positionRule/import',
      payload: {
        key: 'importPositionRules',
        apiParams: {...other, statisticsRuleId: this.initialValue.id}
      },
      autoInit: true,
    })
  }

  /** 导入考核经销商 */
  importDealerRule(other = {}) {
    this.doAction({
      path: 'dealerRule/importFile',
      payload: {
        key: 'importDealerRules',
        apiParams: {...other, statisticsRuleId: this.initialValue.id}
      },
      autoInit: true,
    })
  }


  propsAndStateOnChange = {
    saveScale: this.saveScaleOver.bind(this),
    deleteScaleRule: this.deleteScaleOver.bind(this),
    importPositionRules: this.importPositionRulesOver.bind(this),
    importDealerRules: this.importDealerRulesOver.bind(this),
  };

  saveScaleOver(nextProps, nextState) {
    if (nextProps.saveScale.code == 1) {
      wizNotice.success('操作成功')
      this.setState({scaleVisible: false})
      this.getScaleRuleList();
    } else {
      wizNotice.error(nextProps.saveScale['msg'])
    }
    return true;
  }

  deleteScaleOver(nextProps, nextState) {
    if (nextProps.deleteScaleRule.code == 1) {
      wizNotice.success('操作成功')
      this.getDealerRuleList();
      this.getScaleRuleList()


    } else {
      wizNotice.error(nextProps.deleteScaleRule['msg'])
    }
    return true;
  }

  importPositionRulesOver(nextProps, nextState) {
    if (nextProps.importPositionRules.code == 1) {
      wizNotice.success('操作成功')
      this.setState({
        positionVisible: false,
        importModalKey: new Date().getTime(),
      })
      this.getPositionRuleList();
    } else {
      wizNotice.error(nextProps.importPositionRules['msg'])
    }
    return true;
  }

  importDealerRulesOver(nextProps, nextState) {
    if (nextProps.importDealerRules.code == 1) {
      wizNotice.success('操作成功')
      this.setState({
        dealerVisible: false,
        importModalKey: new Date().getTime(),
      })
      this.getDealerRuleList();
    } else {
      wizNotice.error(nextProps.importDealerRules['msg'])
    }
    return true;
  }


  _onChange = (key) => {
    const {dealerRules, scaleRules} = this.props;
    if (this.state.tabKey !== key) {
      if (key == "dealer" && !dealerRules.code) {
        this.getDealerRuleList();
      } else if (key == "scale" && !scaleRules.code) {
        this.getScaleRuleList();
      }
      this.setState({
        tabKey: key,
        time: new Date().getTime(),
        apiParams: {},
      });
    }
  }

  _removeSelectedRows = () => {
    this.setState({
      selectedRows: 0,
      rows: [],
    })
  };

  /**删除规模 */
  deleteScale(id) {
    this.doAction({
      path: 'scaleRule/delete',
      payload: {
        key: 'deleteScaleRule',
        apiParams: {ids: [id]}
      },
      autoInit: true,
    })
  }

  /**编辑规模 */
  updateScale(record) {
    this.setState({
      scaleRecord: record,
      scaleVisible: true
    })
  }

  addScale() {
    const {positionRules} = this.props;
    if (positionRules && positionRules.data && positionRules.data.length > 0) {
      this._changeVisible('scaleVisible', true)
    } else {
      wizNotice.warn('新增经销商规模考核规则前，请先导入岗位组考核规则！');
    }
  }

  /*岗位组列表 */
  pList() {
    const {history, positionRules} = this.props;
    let dataItems = positionRules && positionRules.data ? positionRules.data : [];
    let timeRule = positionRules && positionRules.data && positionRules.data[0] && positionRules.data[0].requirement == 2 ? true : false;
    let dataTableProps = {
      loading: false,
      columns: positionRuleColumns(timeRule),
      dataItems: {list: dataItems},
      rowKey: "id",
      selectType: false,
      showNum: false,
      isScroll: true,

    };
    return (
      <>
        <WizButton.WizGroup>
          <WizButton className="report-button" title="导入岗位组考核规则" onClick={e => {
            this._changeVisible('positionVisible', true)
          }}>导入岗位组考核规则</WizButton>
        </WizButton.WizGroup>
        <WizDataTable {...dataTableProps} />
        {this._positionModal()}
      </>
    )
  }

  /*规模列表 */
  scaleList() {
    const {history, scaleRules} = this.props;
    let dataItems = scaleRules && scaleRules.data ? scaleRules.data : []
    let dataTableProps = {
      loading: false,
      columns: scaleRuleColumns(this),
      dataItems: {list: dataItems},
      rowKey: "id",
      selectType: false,
      showNum: false,
      isScroll: true,
    };
    return (
      <>
        <WizButton.WizGroup>
          <WizButton className="report-button" icon='plus' type='primary' title="新增"
                     onClick={e => this.addScale()}>新增</WizButton>
        </WizButton.WizGroup>
        <WizAlert type="info"
                  message={" 提示：新增经销商规模考核规则前，请先导入岗位组考核规则！"}
                  showIcon
                  className="report-alert-info"
        />
        <WizDataTable {...dataTableProps} />
        {this._scaleModal()}
      </>
    )
  }

  /*考核经销商列表 */
  dealerList() {
    const {history, dealerRules} = this.props;
    let dataItems = getPageData(dealerRules ? dealerRules.data : {});
    let dataTableProps = {
      loading: false,
      columns: dealerRuleColumns(),
      dataItems: dataItems,
      rowKey: "id",
      onChange: ({pageNum, pageSize}) => {
        this.getDealerRuleList({current: pageNum, size: pageSize});
      },
      selectType: false,
      showNum: false,
      isScroll: true,

    };
    const searchBarProps = {
      columns: dealerRuleColumns(),
      onSearch: (values, isReset) => {
        this.setState({apiParams: values}, () => {
          this.getDealerRuleList({...values});
        })
      }
    };

    return (
      <>
        <WizSearchBar type="grid" {...searchBarProps} />
        <WizButton.WizGroup>
          <WizButton className="report-button" title="导入考核经销商" onClick={e => {
            this._changeVisible('dealerVisible', true)
          }}>导入考核经销商</WizButton>
        </WizButton.WizGroup>
        <WizAlert type="info"
                  message={" 提示：导入考核经销商前，请先导入岗位组考核规则和经销商规模考核规则！"}
                  showIcon
                  className="report-alert-info"
        />
        <WizDataTable {...dataTableProps} />
        <div style={{margin: "20px auto", "text-align": "center"}}>
          <WizDataTable.Pagination {...dataTableProps} />
        </div>
        {this._dealerModal()}
      </>
    )
  }


  _render() {
    const {history, dealerRuleLoading, scaleRuleLoading, positionRuleLoading} = this.props;
    let {selectedRows, rows, classStudentRecord} = this.state;

    return (
      <WizSpin tip={'加载中'} spinning={dealerRuleLoading || scaleRuleLoading || positionRuleLoading}>
        <WizCard title={'参训统计信息'}>
          <WizRow>
            <WizCol span={12} push={2}>
              <span className="ant-table-column-title report-title">参训统计名称: </span>
              <span className="ant-table-row-cell-break-word"> {this.initialValue.name}</span>
            </WizCol>
            <WizCol span={12} push={2}>
              <span className="ant-table-column-title report-title">创建时间: </span>
              <span className="ant-table-row-cell-break-word"> {this.initialValue.createTime}</span>
            </WizCol>
          </WizRow>

        </WizCard>
        <WizCard>
          <WizTabs animated={false} defaultActiveKey="detailed" onChange={this._onChange.bind(this)}>
            <WizTabs.TabPane tab="岗位组考核规则设置" key="post">
              {this.pList()}
            </WizTabs.TabPane>
            <WizTabs.TabPane tab={'经销商规模考核规则设置'} key="scale">
              {this.scaleList()}
            </WizTabs.TabPane>
            <WizTabs.TabPane tab={'考核经销商设置'} key="dealer">
              {this.dealerList()}
            </WizTabs.TabPane>
          </WizTabs>
        </WizCard>
      </WizSpin>
    )
  }

  /**会话框开关 */
  _changeVisible(key, value) {
    this.setState({
      [key]: value,
      scaleRecord: undefined
    })
  }

  /** 导入岗位组考核规则弹框 */
  _positionModal() {
    return <WizModal key={this.state.importModalKey + '_position_modal'}
                     width={900} title={"导入岗位组考核规则"}
                     visible={this.state.positionVisible}
                     onCancel={() => this._changeVisible('positionVisible', false)}
                     footer={null}
    >
      <PositionRuleImport key={this.state.importModalKey + '_position_import'}
                          importPositionRule={this.importPositionRule.bind(this)}/>
    </WizModal>
  }

  /** 导入考核经销商弹框 */
  _dealerModal() {
    return <WizModal key={this.state.importModalKey + '_dealer_modal'}
                     width={900} title={"导入考核经销商"}
                     visible={this.state.dealerVisible}
                     onCancel={() => this._changeVisible('dealerVisible', false)}
                     footer={null}
    >
      <DealerRuleImport key={this.state.importModalKey + '_dealer_import'}
                        importDealerRule={this.importDealerRule.bind(this)}/>
    </WizModal>
  }

  /** 新增编辑岗位组 */
  _scaleModal() {
    let {scaleRecord} = this.state;
    let mtitle = "新增";
    if (scaleRecord) {
      mtitle = "编辑";
    }
    let formProps = {
      ref: 'form',
      // loading: surveyLoading,
      columns: [
        {
          title: '经销商规模',
          name: 'scale',
          formItem: {
            maxLength: 20,
            placeholder: '经销商规模最多输入20个字',
            rules: [
              {
                required: true,
                message: '请输入经销商规模',
              },
              {
                pattern: /^[^\s]*$/,
                message: '经销商规模录入信息不能包含空格'
              }
            ],
            initialValue: scaleRecord ? scaleRecord.scale : undefined
          }
        },
        {
          title: '人数',
          name: 'number',
          formItem: {
            type: 'custom',
            render: (record, form) => {
              const {getFieldDecorator} = form;
              return <> {getFieldDecorator('number', {
                rules: [
                  {
                    required: true,
                    message: '请输入人数',
                  }
                ],
                initialValue: scaleRecord ? scaleRecord.number : undefined,
              })(<WizInputNumber min={1} max={99999}/>)}
              </>
            }
          }
        }
      ],
      onSubmit: this.saveScale.bind(this),
      record: null,
      preview: null,
      formItemLayout: {
        labelCol: {span: 6},
        wrapperCol: {span: 15}
      }
    }
    return <WizModal key={'scale' + new Date().getTime()}
                     width={700} title={mtitle}
                     visible={this.state.scaleVisible}
                     onCancel={() => this._changeVisible('scaleVisible', false)}
                     footer={null}
    >
      <WizForm {...formProps} />
    </WizModal>
  }

}


const Message = ({selectedRows, removeSelectedRows}) => (
  <>
    已选择 {selectedRows} 项
    <WizButton
      style={{height: 20}}
      type="link"
      tooltip="清空"
      onClick={() => removeSelectedRows()}
    >
      {" "}
      清空
    </WizButton>
  </>
);

const mapStateToProps = (state, ownProps) => {
  const {dealerRule, scaleRule, positionRule} = state;
  const dealerRules = modelUtils.getModelEntity(dealerRule, "dealerRules");
  const positionRules = modelUtils.getModelEntity(positionRule, "positionRules");
  const scaleRules = modelUtils.getModelEntity(scaleRule, "scaleRules");
  const saveScale = modelUtils.getModelEntity(scaleRule, "saveScale");
  const deleteScaleRule = modelUtils.getModelEntity(scaleRule, "deleteScaleRule");
  const importPositionRules = modelUtils.getModelEntity(positionRule, "importPositionRules");
  const importDealerRules = modelUtils.getModelEntity(dealerRule, "importDealerRules");
  const load = modelUtils.getLoadingState(state, ['dealerRule', 'scaleRule', 'positionRule']);
  return {
    positionRules,
    importDealerRules,
    dealerRules: dealerRules,
    scaleRules,
    saveScale,
    deleteScaleRule,
    importPositionRules,
    ...load
  }
};

export default connect(mapStateToProps)(AssessmentRulesList);
